import { propNameSelector } from '../utils';
import { yumaposgoodsmapSelector } from './root';

export const yumaposgoodsmapListSelector = propNameSelector(yumaposgoodsmapSelector, 'list');
export const yumaposgoodsmapUpdateListSelector = propNameSelector(yumaposgoodsmapSelector, 'updateList');